import React, { PropsWithChildren } from 'react'
import classnames from 'classnames/bind'
import { observer } from 'mobx-react-lite'

import { Container } from '@caudena/core/ui-kit'
import { RowDeprecated } from '@caudena/core/ui-kit'
import { MagicGrid } from '@caudena/core/ui-kit'
import { Typography } from '@caudena/core/ui-kit'
import { useFormatDate } from '../../../../hooks'

import styles from './index.scss'

const cx = classnames.bind(styles)

interface CaseActivityCardProps {
  className?: string
  icon?: React.ReactElement
  title?: string
  main?: React.ReactNode
  date?: Date
}

const CaseActivityCard: React.FC<PropsWithChildren<CaseActivityCardProps>> = ({
  className,
  icon,
  title,
  main,
  date,
  children,
}) => {
  const formatDate = useFormatDate()
  return (
    <Container className={cx('CaseActivityCard', className)}>
      <MagicGrid className={cx('CaseActivityCardBody')}>
        <div className={cx('TopBlock')}>
          <RowDeprecated className={cx('TitleBlock')} gap={0.5}>
            {icon &&
              React.cloneElement(icon, {
                className: cx('Icon'),
              } as React.HTMLAttributes<HTMLElement>)}
            <Typography color="purple">{title}</Typography>
          </RowDeprecated>
          {main}
          <Typography className={cx('Date')} color="grey4">
            {date ? formatDate(date, 'time') : ''}
          </Typography>
        </div>
        {children}
      </MagicGrid>
    </Container>
  )
}

export default observer(CaseActivityCard)
